import {CircularProgress, Grid} from '@material-ui/core';

const {AppCtx} = require('context/AppContext');
const {useContext, useEffect} = require('react');

const LoadingMessage = () => {
    return (
        <Grid container alignItems='center' justifyContent='space-between'>
            <Grid item>Working...</Grid>
            <Grid item>
                <CircularProgress />
            </Grid>
        </Grid>
    );
};

const StatusMessages = ({
    loading = null,
    success = null,
    error = null,
    loadingMessage = <LoadingMessage />,
    successMessage = 'Success!',
    errorMessage = 'Error!',
}) => {
    const {setSnackProps, setSnackOpen} = useContext(AppCtx);

    useEffect(() => {
        if (loading) {
            setSnackProps({
                severity: 'info',
                message: loadingMessage,
            });
            setSnackOpen(true);
        }
        // eslint-disable-next-line
    }, [loading]);

    useEffect(() => {
        if (success) {
            setSnackProps({
                severity: 'success',
                message: successMessage,
            });
            setSnackOpen(true);
        }
        // eslint-disable-next-line
    }, [success]);

    useEffect(() => {
        if (error) {
            console.debug('error', error);
            setSnackProps({
                severity: 'error',
                message: errorMessage,
            });
            setSnackOpen(true);
        }
        // eslint-disable-next-line
    }, [error]);

    return null;
};

export default StatusMessages;
